
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { Button } from '@/components/ui/button';
import Navbar from '@/components/Navbar';
import Footer from '@/components/Footer';
import CouponSection from '@/components/payment/CouponSection';
import PaymentSummary from '@/components/payment/PaymentSummary';
import PaymentButton from '@/components/payment/PaymentButton';
import PaymentInfo from '@/components/payment/PaymentInfo';
import RazorpayScript from '@/components/payment/RazorpayScript';
import { PaymentProvider } from '@/context/PaymentContext';

const Payment = () => {
  const navigate = useNavigate();

  return (
    <PaymentProvider>
      <div className="min-h-screen flex flex-col bg-gray-50">
        <Navbar />
        <RazorpayScript />
        
        <main className="flex-grow py-10 px-4 sm:px-6 lg:px-8">
          <div className="max-w-2xl mx-auto">
            <Button 
              variant="ghost" 
              onClick={() => navigate('/')}
              className="mb-6 text-brand-blue"
            >
              <ArrowLeft className="mr-2 h-4 w-4" />
              Back to packages
            </Button>

            <div className="bg-white rounded-xl shadow-sm p-6 mb-6">
              <h1 className="text-2xl font-bold text-brand-blue mb-6">
                Complete Your Purchase
              </h1>
              
              <PaymentSummary />
              
              <div className="space-y-6 mt-6">
                <CouponSection />
                <PaymentButton />
              </div>
            </div>

            <PaymentInfo />
          </div>
        </main>

        <Footer />
      </div>
    </PaymentProvider>
  );
};

export default Payment;
